import { render } from "./TheZoneContainer.vue?vue&type=template&id=10505990"
import script from "./TheZoneContainer.vue?vue&type=script&lang=js"
export * from "./TheZoneContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__